import { render, staticRenderFns } from "./ForumThreadPage.vue?vue&type=template&id=dfb86806&"
import script from "./ForumThreadPage.vue?vue&type=script&lang=js&"
export * from "./ForumThreadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfb86806')) {
      api.createRecord('dfb86806', component.options)
    } else {
      api.reload('dfb86806', component.options)
    }
    module.hot.accept("./ForumThreadPage.vue?vue&type=template&id=dfb86806&", function () {
      api.rerender('dfb86806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/forum/ForumThreadPage.vue"
export default component.exports